define('v3/Pages/Settings/ViewModels/Browser.ViewModel',[
	'jquery',
	'knockout',
	'lodash',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/Pages/Settings/Services/Browser.Backend',
	'v3/Common/Helpers/Validation/Validation.Helper',
	'knockout-track-changes'
],
function ($, ko, _, frontend, backend, validationHelper) {
	function BrowserSettingsViewModel (options) {
		var self = this;
		self.navBackButtonParams = options.navBackButtonParams;

		self.isBrowserEnabled = ko.observable(false).extend({ trackChange: true });
		self.isChildSafeBrowserEnabled = ko.observable(true).extend({ trackChange: true });

		self.safeBrowserStartUrl = ko.observable('').extend({
			trackChange: true,
			validation: {
				validator: function (val) {
					if (!val) {
						return true;
					}
					return validationHelper.isValidUrl(val);
				},
				message: Strings.AddValidUrl
			}
		});
		self.browserStartUrl = ko.observable('').extend({
			trackChange: true,
			validation: {
				validator: function (val) {
					if (!val) {
						return true;
					}
					return validationHelper.isValidUrl(val);
				},
				message: Strings.AddValidUrl
			}
		});

		self.newURL = ko.observable().extend({
			validation: {
				validator: function (val) {
					if (!val) {
						return true;
					}
					return validationHelper.isValidUrl(val);
				},
				message: Strings.AddValidUrl
			}
		});

		self.urls = ko.observableArray();

		self.sortedUrls = ko.computed(function () {
			return self.urls().sort(function (a, b) {
				return a.url.localeCompare(b.url);
			});
		});

		backend.getWebAppAllowedUrls()
			.done(function (data) {
				self.urls(data);
			});

		backend.getBrowserSettings()
			.done(function (data) {
				self.isBrowserEnabled.setOriginalValue(data.isBrowserEnabled);
				self.isBrowserEnabled(data.isBrowserEnabled);
				self.isChildSafeBrowserEnabled.setOriginalValue(data.isChildSafeBrowserEnabled);
				self.isChildSafeBrowserEnabled(data.isChildSafeBrowserEnabled);
				self.safeBrowserStartUrl.setOriginalValue(data.safeBrowserStartUrl || data.defaultBrowserStartUrl);
				self.safeBrowserStartUrl(data.safeBrowserStartUrl || data.defaultBrowserStartUrl);
				self.browserStartUrl.setOriginalValue(data.browserStartUrl || data.defaultBrowserStartUrl);
				self.browserStartUrl(data.browserStartUrl || data.defaultBrowserStartUrl);
			});

		self.saveBrowserSettings = function () {
			backend.updateBrowserSettings({
				isBrowserEnabled: self.isBrowserEnabled(),
				isChildSafeBrowserEnabled: self.isChildSafeBrowserEnabled(),
				safeBrowserStartUrl: self.safeBrowserStartUrl() || null,
				browserStartUrl: self.browserStartUrl() || null
			}).done(function () {
				frontend.notification.success({
					text: Strings.BrowserSettingsSavedSuccesfully
				});
				self.isBrowserEnabled.setOriginalValue(self.isBrowserEnabled());
				self.isBrowserEnabled.valueHasMutated();
				self.isChildSafeBrowserEnabled.setOriginalValue(self.isChildSafeBrowserEnabled());
				self.isChildSafeBrowserEnabled.valueHasMutated();
				self.safeBrowserStartUrl.setOriginalValue(self.safeBrowserStartUrl());
				self.safeBrowserStartUrl.valueHasMutated();
				self.browserStartUrl.setOriginalValue(self.browserStartUrl());
				self.browserStartUrl.valueHasMutated();
			});
		};

		self.addNewUrl = function () {
			if (validationHelper.isValidUrl(self.newURL())) {
				backend.addWebAppAllowedUrl(self.newURL())
					.done(function (safeBrowserAllowedUrlId) {
						if (safeBrowserAllowedUrlId) {
							self.urls.push({
								safeBrowserAllowedUrlId: safeBrowserAllowedUrlId,
								url: self.newURL()
							});
							self.newURL('');
						}
					});
			}
		};

		self.deleteUrl = function (safeBrowserAllowedUrl) {
			frontend.confirm.show({
				title: Strings.ConfirmTitle,
				content: Strings.DeleteWebAppAllowedUrlConfirmation,
				buttons: [Strings.YesButton, Strings.CancelButton]
			}).then(function () {
				backend.deleteWebAppAllowedUrl(safeBrowserAllowedUrl.safeBrowserAllowedUrlId)
					.done(function () {
						self.urls.remove(safeBrowserAllowedUrl);

						frontend.notification.success({
							text: Strings.WebAppAllowedUrlDeleted
						});
					});
			});
		};

		self.isDirty = ko.computed(function () {
			var isDirty = false;
			if (
				self.isBrowserEnabled.isDirty() ||
				self.isChildSafeBrowserEnabled.isDirty() ||
				self.safeBrowserStartUrl.isDirty() ||
				self.browserStartUrl.isDirty()
			) {
				isDirty = true;
				$(window).off('beforeunload.browsersettings').on('beforeunload.browsersettings', function () {
					return Strings.ConfirmationBeforeSave;
				});
			} else {
				$(window).off('beforeunload.browsersettings');
			};
			return isDirty;
		});
	};

	return BrowserSettingsViewModel;
}
);
